import { useParams } from 'react-router-dom';

import withAuthorizer from 'components/ui/withAuthorizer';
import ReportHeader from 'components/reports/ReportHeader';
import ReportFilters from 'components/reports/ReportFilters';
import WidgetList from 'components/reports/WidgetList';

import { Resources } from 'helpers/ResourceHelper';

const ReportPage = () => {
  const { reportId } = useParams();

  return (
    <>
      <ReportHeader reportId={reportId} />
      <div className="container mt-4 d-flex">
        <section className="section " style={{ width: 250, paddingRight: 16, borderRight: '1px solid #ccc' }}>
          <h6 className="mb-3 text-muted">Filtros</h6>
          <ReportFilters reportId={reportId} />
        </section>

        <section className="section flex-fill ms-3">
          <WidgetList reportId={reportId} />
        </section>
      </div>
    </>
  );
};

export default withAuthorizer(ReportPage, [Resources.REPORT_VIEW]);
